var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-collapse",
        {
          model: {
            value: _vm.beneficiarioId,
            callback: function($$v) {
              _vm.beneficiarioId = $$v
            },
            expression: "beneficiarioId"
          }
        },
        _vm._l(_vm.dependentes, function(dependente) {
          return _c(
            "el-collapse-item",
            {
              key: dependente.cpf,
              attrs: { title: dependente.nome, name: dependente.cpf }
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: { label: "Nome:", content: dependente.nome }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: { label: "CPF:", content: dependente.cpf }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("app-display", {
                        attrs: {
                          label: "Data de Nascimento:",
                          content: _vm.formatDate(
                            dependente.dataNascimento,
                            "DD/MM/YYYY"
                          )
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              dependente.documentos && dependente.documentos.length > 0
                ? _c("listagem-documentos", {
                    attrs: {
                      documentos: dependente.documentos,
                      protocoloCadastroOriginal: _vm.protocolo,
                      idDependente: dependente._id,
                      ownerDocumento: "DEPENDENTE"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-71773b3c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71773b3c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppDependentes.vue
// module id = null
// module chunks = 